// extracted by mini-css-extract-plugin
export default {"card":"t3-z"};